var UIInputMask = (function ($) {

    var Self = UIInputMask = function () {
        var that = this;

        // DOM

        // CONST

        // INIT
        that.init();
    }


    var def = function (var1, var2) {
        for (var i = 0, len = arguments.length; i < len; i++) {
            if (typeof arguments[i] !== 'undefined') {
                return arguments[i];
            }
        }
        return undefined;
    };

    Self.def = def;

    // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode
    UIInputMask.prototype.INPUTMODE = {
        email: 'email', // открытие буквенной клавиатуры, необходимо использовать для цифробуквенных масок (для корректной работы на телефонах)
        numeric: 'numeric', // открытие циферной клавиатуры, необходимо использовать для циферных масок (для корректной работы на телефонах)б
        none: 'none', // режим, при котором клавиатура вообще не открывается
        text: 'text' // некорректно работает с jquery input mask на телефонах (позволяет ввести только один символ в input)
    };

    UIInputMask.prototype.CASING = {
        upper: 'upper',
        lower: 'lower'
    };

    UIInputMask.prototype.init = function () {
        //
    }

    UIInputMask.prototype.__inputMask = function ($input, mask_options) {
        var that = this;
        var complete = false;
        var $input_error_symbol = $input.data('error-symbol');

        if (!mask_options.inputmode) {
            mask_options.inputmode = UIInputMask.prototype.INPUTMODE.numeric;
        }

        $input.inputmask('remove');
        $input.inputmask({
            keepStatic: false,
            autoUnmask: true,
            ...mask_options,
            onKeyValidation: function (key, result) {
                var $input = $(this);
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_symbol, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                var $input = $(this);
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });
    }

    UIInputMask.prototype.initPhoneMask = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-phone');
        var valid_masks = [
                '+ox{10,14}',       // o = other / 11-15 digits o - first digit + x – from 10 to 14 times
                '+7(xxx)xxx-xx-xx'  // Russia
            ];

        that.__inputMask($input, {
            mask: valid_masks,
            definitions: {
                'x': {
                    validator: "[0-9]"
                },
                'o': {
                    validator: "[12345689]"
                }
            },
        })

        that.__phoneActionHandler($input);
    };

    UIInputMask.prototype.initHumanHeightMask = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-human-height');

        that.__inputMask($input, {
            mask: 'a{1}99',
            inputmode: 'numeric',
            placeholder: '_',
            definitions: {
                'a': {
                    validator: "[1-2]"
                },
            }    
        })
    };

    UIInputMask.prototype.initNumericMask = function ($wrapper) {
        var that = this,
            $input = $wrapper.find('.js-numeric-input');

        that.__inputMask($input, {
            regex: "[0-9]*"
        })
    };

    UIInputMask.prototype.initCountMask = function ($wrapper, min = 0, max = 10) {
        var that = this;
        var $input = $wrapper.find('.js-count');

        that.__inputMask($input, {
            alias: 'numeric',
            allowMinus: false,
            rightAlign: false,
            min: min,
            max: max
        })
    };

    UIInputMask.prototype.__phoneActionHandler = function ($input) {
        var that = this;

        $input.on('blur', function () {
            var $input = $(this),
                result = $.trim($input.val()),
                required = $input.attr('required'),
                error_empty = $input.data('error-empty'),
                error_invalid = $input.data('error-invalid');

            if ((!result || result === '+7') && required) {
                UIInput.prototype.setError($input, error_empty);
            }else if (result && !that.__validatePhone(result)) {
                UIInput.prototype.setError($input, error_invalid);
            }else{
                UIInput.prototype.clearError($input);
            }
        });
    };

    UIInputMask.prototype.__validatePhone = function (value) {
        var that = this,
            value_trim = value.replace(/[^0-9]/g, ''),
            value_min = 11,
            value_max = 15;

        if ((value_trim.length < value_min) || (value_trim.length > value_max)) {
            return false;
        }

        return true;
    };

    UIInputMask.prototype.isValidLength = function (value, min, max = Infinity) {
        var that = this,
            value_trim = value.replace(/[-._ ]/gm, '');

        if ((value_trim.length < min) || (value_trim.length > max)) {
            return false;
        }

        return true;
    };

    UIInputMask.prototype.validateBirthday = function (value, allow_empty_value = false) {
        if (allow_empty_value && !value) {
            return true;
        }

        var birthday_formatted = dayjs(value, 'DD.MM.YYYY', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            date_before = dayjs.utc('01.01.1900', 'DD.MM.YYYY', true),
            valid_date_birth = birthday_formatted.isValid(),
            // https://day.js.org/docs/ru/plugin/is-between
            valid_date_between = birthday_formatted.isBetween(date_before, datetime_now, 'day', '[)');

        if (!valid_date_birth || !valid_date_between) {
            return false;
        }

        return true;
    };

    UIInputMask.prototype.isValidDateAfterNow = function (value) {
        var date_formatted = dayjs(value, 'DD.MM.YYYY', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            valid_date = date_formatted.isValid(),
            // https://day.js.org/docs/ru/plugin/is-same-or-after
            valid_date_after = date_formatted.isSameOrAfter(datetime_now, 'day');

        return valid_date && valid_date_after;
    };

    UIInputMask.prototype.validateNameFieldsLength = function ($wrapper) {
        var that = this,
            $inputs_name = $wrapper.find('.js-name'),
            input_language = 'lat', // default: latin
            total_character_count = 0,
            is_valid = false;

        $inputs_name.each(function () {
            var $input = $(this),
                input_value = $input.val().trim().toLowerCase();

            total_character_count = total_character_count + input_value.length;
            // если найден хотя бы один символ на кириллице
            if (/[\u0400-\u04FF]/.test(input_value)) {
                input_language = 'cyr';
            }
        });

        if (input_language === 'cyr') {
            if (total_character_count <= 43) {
                is_valid = true;
            }
        } else {
            if (total_character_count <= 50) {
                is_valid = true;
            }
        }

        return is_valid;
    };

    UIInputMask.prototype.validateNameCharset = function ($wrapper) {
        var that = this,
            $inputs_name = $wrapper.find('.js-consistent-name'),
            first_language = null,
            is_valid = true;

        $inputs_name.each(function () {
            if ($(this).val().length === 0) {
                return;
            }
            
            var $input = $(this),
                input_value = $input.val().trim().toLowerCase();

            if (0 === input_value.length) {
                return;
            }

            var has_cyrillic = /[\u0400-\u04FF]/.test(input_value),
                has_latin = /[\u0041-\u005A\u0061-\u007A]/.test(input_value),
                input_language = has_cyrillic ? 'cyr' : 'lat';

            if (has_cyrillic && has_latin) {
                is_valid = false;
            }
            if (null === first_language) {
                first_language = input_language;
            } else if (input_language !== first_language) {
                is_valid = false;
            }
        });

        return is_valid;
    };

    UIInputMask.prototype.validateNameEmptyFields = function ($wrapper) {
        var that = this,
            $inputs_name = $wrapper.find('.js-input-part-name'),
            is_valid = true;

        $inputs_name.each(function () {
            var $input = $(this)
            
            if ($input.val().length === 0 && !$input.hasClass('js-empty-name')) {
                is_valid = false;
            }
        });

        return is_valid;
    };

    UIInputMask.prototype.initCardLastNumbers = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-card-last-numbers');

        that.__inputMask($input, {
            mask: '\\*\\*\\*\\* \\*\\*\\*\\* \\*\\*\\*\\* 9999'
        });
    };

    UIInputMask.prototype.initINN = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-inn');

        that.__inputMask($input, {
            mask: '9999999999[99]'
        });
    };

    UIInputMask.prototype.initBIK = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-bik');

        that.__inputMask($input, {
            mask: '999999999'
        });
    };

    UIInputMask.prototype.initBookingNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-booking-number');

        that.__inputMask($input, {
            mask: '******',
            inputmode: UIInputMask.prototype.INPUTMODE.email
        });
    };

    UIInputMask.prototype.initTicketNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-ticket-number');

        that.__inputMask($input, {
            mask: '\\3\\1\\69999999999'
        });
    };

    UIInputMask.prototype.initAccountNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-account-number');

        that.__inputMask($input, {
            mask: '99999999999999999999'
        });
    };

    UIInputMask.prototype.initPnrMask = function ($wrapper, options = []) {
        var that = this;
        var $input = $wrapper.find('.js-pnr'),
            pnr_length = def(options['pnr_length'], 6),
            ticket_number_length = def(options['ticket_number_length'], 13),
            with_pnr = def(options['with_pnr'], true),
            with_ticket_number = def(options['with_ticket_number'], true),
            inputmode = UIInputMask.prototype.INPUTMODE.email,
            mask = [];

        if (with_pnr) {
            mask.push('b{' + pnr_length + '}');
        }

        if (with_ticket_number) {
            mask.push('n{' + ticket_number_length + '}');

            // если в поле нужно вводить только номер билета, то на телефонах открываем клавиатуру только с цифрами
            if (!with_pnr) {
                inputmode = UIInputMask.prototype.INPUTMODE.numeric;
            }
        }

        that.__inputMask($input, {
            keepStatic: true, 
            mask: mask,
            definitions: {
                'b': {
                    // both: cyrillic + latin + number
                    validator: '[0-9\u0041-\u005A\u0061-\u007A\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F]',
                    casing: UIInputMask.prototype.CASING.upper
                },
                'n': {
                    validator: '[0-9]'
                }
            },
            // обязательно задавать параметр placeholder='', если у маски задана длина
            // так как иначе на планшетах ввод работает некорректно
            inputmode: inputmode,
            placeholder: ''
        });
    };

    UIInputMask.prototype.initEmailMask = function ($wrapper) {
        var that = this,
            $input = $wrapper.find('.js-email'),
            error_text = $input.data('error-symbol'),
            complete = false;

        UIInput.prototype.clearError($input);

        $input.inputmask({
            mask: '*{*}',
            jitMasking: true,
            placeholder: '',
            definitions: {
                '*': {
                    validator: "[@.0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                    casing: UIInputMask.prototype.CASING.lower
                }
            },
            onBeforePaste: function (pastedValue, opts) {
                pastedValue = pastedValue.toLowerCase();
                return pastedValue.replace('mailto:', '');
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, error_text, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });
    };

    UIInputMask.prototype.initEmailValidate = function ($wrapper) {
        var $input_email = $wrapper.find('.js-email');

        $input_email.on('blur', function () {
            var $input = $(this),
                result = $.trim($input.val()),
                required = $input.attr('required'),
                error_invalid = $input.data('error-invalid'),
                error_empty = $input.data('error-empty');

            if (!result && required) {
                UIInput.prototype.setError($input, error_empty, true);
            }else if (result && !$.sa.validate.email(result)) {
                UIInput.prototype.setError($input, error_invalid, true);
            } else {
                UIInput.prototype.clearError($input);
            }
        });

        $input_email.on('keydown', function () {
            var $input = $(this);

            UIInput.prototype.clearError($input);
        });
    };

    UIInputMask.prototype.initDateMask = function ($wrapper, $input = null, mask_options = {}) {
        var that = this;

        if (!$input) {
            $input = $wrapper.find('.js-date');
        }
        
        that.__inputMask($input, {
            mask: '(0b)|(d9)|(3c).(0b)|(1a).(1f)|(2e)99',
            placeholder: '_',
            autoUnmask: false,
            definitions: {
                '0': {
                    validator: "0"
                },
                '3': {
                    validator: "3"
                },
                'a': {
                    validator: "[0-2]"
                },
                'b': {
                    validator: "[1-9]"
                },
                'c': {
                    validator: "[01]"
                },
                'd': {
                    validator: "[12]"
                },
                'e': {
                    validator: "[01]"
                },
                'f': {
                    validator: "[9]"
                }
            },
            ...mask_options
        });
    };

    UIInputMask.prototype.validateCorrectDate = function (value, allow_empty_value = false) {
        if (allow_empty_value && !value) {
            return true;
        }

        var input_date = dayjs(value, 'DD.MM.YYYY', true),
            valid_input_date = input_date.isValid();

        if (!valid_input_date) {
            return false;
        }

        return true;
    };

    
    UIInputMask.prototype.initTimeMask = function ($wrapper, mask_options) {
        var that = this;
        var $input = $wrapper.find('.js-time');

        that.__inputMask($input, {
            mask: '99:99',
            placeholder: '_',
            ...mask_options
        });
    };

    UIInputMask.prototype.initDateTimeMask = function ($wrapper, $input = null, mask_options) {
        var that = this;

        if (!$input) {
            $input = $wrapper.find('.js-date-time');
        }

        that.__inputMask($input, {
            mask: 'a9.b9.cd99 99:99',
            placeholder: '_',
            definitions: {
                'a': {
                    validator: "[0-3]"
                },
                'b': {
                    validator: "[01]"
                },
                'c': {
                    validator: "[12]"
                },
                'd': {
                    validator: "[09]"
                }
            },
            ...mask_options
        });
    };

    UIInputMask.prototype.initBirthdayMask = function ($input) {
        var that = this,
            complete = false,
            $input_error_symbol = $input.data('error-symbol');

        $input.inputmask({
            mask: '(0b)|(d9)|(3c).(0b)|(1a).(1f)|(2e)99',
            inputmode: 'numeric',
            placeholder: '_',
            definitions: {
                '0': {
                    validator: "0"
                },
                '3': {
                    validator: "3"
                },
                'a': {
                    validator: "[0-2]"
                },
                'b': {
                    validator: "[1-9]"
                },
                'c': {
                    validator: "[01]"
                },
                'd': {
                    validator: "[12]"
                },
                'e': {
                    validator: "[01]"
                },
                'f': {
                    validator: "[9]"
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_symbol, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });
    };


    UIInputMask.prototype.initNameInputMask = function ($input, type = 'both', reset_value = true) {
        var that = this,
            $input_error_text = $input.data('error-text'),
            $input_warning_text = $input.data('warning-character'),
            complete = false,
            pattern;

        if (type === 'cyr') {
            pattern = 'c';
        }
        if (type === 'lat') {
            pattern = 'l';
        }
        if (type === 'both') {
            pattern = 'b';
        }

        $input
            .inputmask('remove');

        if (reset_value) {
            $input
                .val('');
        }

        $input
            .trigger('input');

        UIInput.prototype.clearError($input);

        $input.inputmask({
            mask: pattern + '{*}',
            inputmode: that.INPUTMODE.email,
            definitions: {
                'c': {
                    // cyrillic only, exclude ъЪ
                    // https://jrgraphix.net/r/Unicode/0400-04FF
                    // last characters: space and minus
                    validator: '[\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                },
                'l': {
                    // latin only
                    // https://jrgraphix.net/r/Unicode/0020-007F
                    validator: '[\u0041-\u005A\u0061-\u007A]'
                },
                'b': {
                    // both: cyrillic + latin
                    validator: '[\u0041-\u005A\u0061-\u007A\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
                if (key.code === 'Space' || key.code === 'Minus') {
                    UIInput.prototype.setError($input, $input_warning_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            oncomplete: function () {
                complete = true;
                that.__inputReplace($input);
            },
            onincomplete: function () {
                complete = false;
                that.__inputReplace($input);
            },
            onBeforePaste: function () {
                that.__inputReplace($input);
            },
            oncleared: function () {
                complete = false;
            }
        });
    };

    UIInputMask.prototype.__inputReplace = function ($input) {
        var cursor_position = $input.prop('selectionStart');

        $input.val($input.val().replace(/[ -]/gm, ''));
        $input.val($input.val().replace(/ё/gm, 'е'));
        $input.val($input.val().replace(/Ё/gm, 'Е'));
        $input.val($input.val().replace(/^[ьЬ]*/gm, ''));

        $input
            .prop('selectionStart', cursor_position)
            .prop('selectionEnd', cursor_position);
    };

    UIInputMask.prototype.initHelpDeskNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-helpdesk-number');

        that.__inputMask($input, {
            inputmode: 'text',
            mask: 'aaa-99999',
            placeholder: '_',
        });
    };

    UIInputMask.prototype.initCertificateNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-input-certificate');

        that.__inputMask($input, {
            inputmode: that.INPUTMODE.text,
            casing: that.CASING.upper,
            autoUnmask: false,
            definitions: {
                'l': {
                    // latin only
                    // https://jrgraphix.net/r/Unicode/0020-007F
                    validator: '[\u0041-\u005A\u0061-\u007A]'
                }
            },
            mask: 'lll-99999',
            placeholder: '_'
        });
    };

    UIInputMask.prototype.initFlightNumber = function ($wrapper) {
        var that = this;
        var $input = $wrapper.find('.js-input-flight-number');

        that.__inputMask($input, {
            inputmode: that.INPUTMODE.text,
            casing: that.CASING.upper,
            autoUnmask: false,
            mask: '5N-9{3,7}',
        });
    };

    return UIInputMask;
})($);
